import React, { useEffect } from "react";
import axios from "axios";
import Modal from "./modal";
import Input from "../../forms/input";
import CheckBox from "../../forms/check-box";
import Select from "../../forms/select";
import { countryList } from "../../utility/countries";
import { useResources } from "../../utility/use-resources";
import bbCodeParser from "../../utility/bb-code-parser";
import styled from "styled-components";
import ImageLoaderInViewWrapper from "./image-loader";
import Cookies from 'js-cookie'
import { Gap } from "../../../vicbooth/shared/ui/gap";

const ImageWrapper = styled.div`
  width: 100%;
  img {
    max-width: 100%;
  }
`

const Center = styled.div`
  text-align: center;
`

const ButtonList = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  button {
    cursor: pointer;
  }
`

const NewsModal = (props) => {
  const [r] = useResources("general", "newsModal");

  useEffect(() => {
    if (!r('visible')) return
    Cookies.set('newsModalSeen', true, { expires: 1 })
  }, [])

  if (!r('visible') || Cookies.get('newsModalSeen')) return null

  return (
    <Modal onClose={props.onClose} style={{maxWidth: 600}}>
      <ImageWrapper>
        <a href={r('link.url')}><ImageLoaderInViewWrapper source={r('image')?.[0]?.downloadURL} /></a>
      </ImageWrapper>
      <Gap />
      <Center>
        {r('description') && <>
          <p>{r('description')}</p>
          <Gap />
        </>
        }
        <ButtonList>
          {r("link.text") && (
            <>
              <a
                href={r('link.url')}
                className="link-primary link-dark"
              >
              {r("link.text")}
            </a>
            <Gap />
          </>
          )}
          <button className="link-dark" onClick={props.onClose}>Close</button>
        </ButtonList>
      </Center>
    </Modal>
  );
};

export default NewsModal;
